export class TokenContextUtils {
  public static getKey(baseKey: string, key?: string): string {
    return key ? `${baseKey}-${key}` : baseKey;
  }
}
